import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Body = styled.section`
	padding: ${({ paddingTop }) => `${paddingTop ?? '2'}rem 2rem 2rem`};
	text-align: ${({ centered }) => centered ? 'center' : 'left'};
	font-family: ${({ theme }) => theme['base-font-family']};
	line-height: 1.5;
	font-weight: 400;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-bottom: 1.5rem;
		font-weight: 500;
	}
`;

const ModalBody = ({ ...props }) => <Body {...props} />;

ModalBody.propTypes = {
	centered: PropTypes.bool,
	paddingTop: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
};

export default ModalBody;
